'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = reducer;
exports.setSchoolName = setSchoolName;
exports.setMajorName = setMajorName;
exports.setYear = setYear;
exports.setBatchId = setBatchId;
exports.initData = initData;
exports._getFilters = _getFilters;
exports.toggleFilter = toggleFilter;
exports.setFilterScore = setFilterScore;
exports.resetFilter = resetFilter;
exports.reloadHiscoreList = reloadHiscoreList;
exports.loadMoreHiscoreList = loadMoreHiscoreList;
exports.getBatches = getBatches;
var t = {
    GET_FILTERS: 'hiscore/year/GET_FILTERS',
    GET_FILTERS_SUCCESS: 'hiscore/year/GET_FILTERS_SUCCESS',
    GET_FILTERS_FAIL: 'hiscore/year/GET_FILTERS_FAIL',

    RELOAD_HISCORE_LIST: 'hiscore/year/RELOAD_HISCORE_LIST',
    RELOAD_HISCORE_LIST_SUCCESS: 'hiscore/year/RELOAD_HISCORE_LIST_SUCCESS',
    RELOAD_HISCORE_LIST_FAIL: 'hiscore/year/RELOAD_HISCORE_LIST_FAIL',

    LOAD_MORE_HISCORE_LIST: 'hiscore/year/LOAD_MORE_HISCORE_LIST',
    LOAD_MORE_HISCORE_LIST_SUCCESS: 'hiscore/year/LOAD_MORE_HISCORE_LIST_SUCCESS',
    LOAD_MORE_HISCORE_LIST_FAIL: 'hiscore/year/LOAD_MORE_HISCORE_LIST_FAIL',

    GET_BATCHES: "hiscore/year/GET_BATCHES",
    GET_BATCHES_SUCCESS: "hiscore/year/GET_BATCHES_SUCCESS",
    GET_BATCHES_FAIL: "hiscore/year/GET_BATCHES_FAIL",

    GET_NEW_BATCHES: "hiscore/year/GET_NEW_BATCHES",
    GET_NEW_BATCHES_SUCCESS: "hiscore/year/GET_NEW_BATCHES_SUCCESS",
    GET_NEW_BATCHES_FAIL: "hiscore/year/GET_NEW_BATCHES_FAIL",

    TOGGLE_FILTER: 'hiscore/year/TOGGLE_FILTER',
    RESET_FILTER: 'hiscore/year/RESET_FILTER',
    SET_SCHOOLNAME: 'hiscore/year/SET_SCHOOLNAME',
    SET_MAJORNAME: 'hiscore/year/SET_MAJORNAME',
    SET_FILTER_SCORE: 'hiscore/year/SET_FILTER_SCORE',
    SET_YEAR: 'hiscore/year/SET_YEAR',
    SET_BATCH_ID: 'hiscore/year/SET_BATCH_ID',
    INIT_DATA: 'hiscore/year/INIT_DATA'
};

var initialState = {
    filters: [],
    selectedFilters: null,
    hiscoreList: [],
    isReloaded: false,
    schoolName: '',
    majorName: '',
    pager: {},
    // maxAvgScore: '',
    // minAvgScore: '',
    maxScore: '',
    minScore: '',
    year: 2026,
    batchId: 1,
    loading: true,
    sixBatches: [],
    sevenBatches: [],
    eightBatches: [],
    nineBatches: [],
    twentyBatches: [],
    twentyOneBatches: [],
    twentyTwoBatches: [],
    twentyThreeBatches: [],
    twentyFourBatches: []
};

function reducer() {
    var _extends2;

    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case t.GET_FILTERS_SUCCESS:
            if (!action.result.data.success) {
                return state;
            }
            return _extends({}, state, {
                filters: action.result.data.data
            });
        case t.LOAD_MORE_HISCORE_LIST_SUCCESS:
            {
                if (!action.result.data.success) {
                    return state;
                }
                var res = _extends({}, state, {
                    pager: action.result.data.pager
                });
                res.hiscoreList = res.hiscoreList.concat(action.result.data.data);
                return res;
            }
        case t.RELOAD_HISCORE_LIST:
            return _extends({}, state, {
                isReloaded: false,
                loading: true
            });
        case t.RELOAD_HISCORE_LIST_SUCCESS:
            if (!action.result.data.success) {
                return _extends({}, state, {
                    pager: null,
                    hiscoreList: [],
                    isReloaded: true,
                    loading: false
                });
            }
            return _extends({}, state, {
                pager: action.result.data.pager,
                hiscoreList: action.result.data.data,
                isReloaded: true,
                loading: false
            });
        case t.RELOAD_HISCORE_LIST_FAIL:
            return _extends({}, state, {
                loading: false
            });
        case t.TOGGLE_FILTER:
            {
                var _res = _extends({}, state);
                var oldObj = _res.selectedFilters;
                var SelectedFilters = oldObj ? _extends({}, oldObj) : {};
                var selectedTypeFilters = SelectedFilters[action.filterType];
                selectedTypeFilters = selectedTypeFilters ? selectedTypeFilters : [];
                var i = selectedTypeFilters.map(function (sf) {
                    return sf.id;
                }).indexOf(action.filter.id);
                i > -1 ? selectedTypeFilters.splice(i, 1) : selectedTypeFilters.push(action.filter);
                SelectedFilters[action.filterType] = selectedTypeFilters;
                _res.selectedFilters = SelectedFilters;
                return _res;
            }
        case t.RESET_FILTER:
            return _extends({}, state, {
                selectedFilters: null,
                // maxAvgScore: '',
                // minAvgScore: '',
                maxScore: '',
                minScore: ''
            });
        case t.SET_SCHOOLNAME:
            return _extends({}, state, {
                schoolName: action.schoolName
            });
        case t.SET_MAJORNAME:
            return _extends({}, state, {
                majorName: action.majorName
            });
        case t.SET_FILTER_SCORE:
            return _extends({}, state, (_extends2 = {}, _extends2[action.scoreType] = action.score, _extends2));
        case t.SET_YEAR:
            return _extends({}, state, {
                year: action.year
            });
        case t.SET_BATCH_ID:
            return _extends({}, state, {
                batchId: action.batchId
            });
        case t.INIT_DATA:
            return _extends({}, state, {
                isReloaded: false,
                schoolName: '',
                majorName: '',
                pager: {},
                year: 2026,
                batchId: 1,
                loading: true
            });
        case t.GET_BATCHES_SUCCESS:
            if (!action.result.data.success) {
                return _extends({}, state);
            }
            return _extends({}, state, {
                sixBatches: action.result.data.data
            });
        case t.GET_NEW_BATCHES_SUCCESS:
            if (!action.result.data.success) {
                return _extends({}, state);
            }
            if (action.year == '2017') {
                return _extends({}, state, {
                    sevenBatches: action.result.data.data
                });
            } else if (action.year === "2018") {
                return _extends({}, state, {
                    eightBatches: action.result.data.data
                });
            } else if (action.year === "2019") {
                return _extends({}, state, {
                    nineBatches: action.result.data.data
                });
            } else if (action.year === "2020") {
                return _extends({}, state, {
                    twentyBatches: action.result.data.data
                });
            } else if (action.year === "2021") {
                return _extends({}, state, {
                    twentyOneBatches: action.result.data.data
                });
            } else if (action.year === "2022") {
                return _extends({}, state, {
                    twentyTwoBatches: action.result.data.data
                });
            } else if (action.year === "2023") {
                return _extends({}, state, {
                    twentyThreeBatches: action.result.data.data
                });
            } else {
                return {
                    twentyFourBatches: action.result.data.data
                };
            }
        default:
            return state;
    }
}

function setSchoolName(schoolName) {
    return {
        type: t.SET_SCHOOLNAME,
        schoolName: schoolName
    };
}

function setMajorName(majorName) {
    return {
        type: t.SET_MAJORNAME,
        majorName: majorName
    };
}

function setYear(year) {
    return {
        type: t.SET_YEAR,
        year: year
    };
}

function setBatchId(batchId) {
    return {
        type: t.SET_BATCH_ID,
        batchId: batchId
    };
}

function initData() {
    return {
        type: t.INIT_DATA
    };
}

function _getFilters() {
    return {
        types: [t.GET_FILTERS, t.GET_FILTERS_SUCCESS, t.GET_FILTERS_FAIL],
        promise: function () {
            function promise(client) {
                return client.get('/api/bp/hiscore/filter');
            }

            return promise;
        }()
    };
}

function toggleFilter() {
    var filterType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return {
        type: t.TOGGLE_FILTER,
        filterType: filterType,
        filter: filter
    };
}

function setFilterScore(score, type) {
    return {
        type: t.SET_FILTER_SCORE,
        scoreType: type,
        score: score
    };
}

function resetFilter() {
    return {
        type: t.RESET_FILTER
    };
}

function _createQuery(_ref) {
    var year = _ref.year,
        batchId = _ref.batchId,
        _ref$schoolName = _ref.schoolName,
        schoolName = _ref$schoolName === undefined ? '' : _ref$schoolName,
        _ref$majorName = _ref.majorName,
        majorName = _ref$majorName === undefined ? '' : _ref$majorName,
        maxAvgScore = _ref.maxAvgScore,
        minAvgScore = _ref.minAvgScore,
        maxScore = _ref.maxScore,
        minScore = _ref.minScore,
        pager = _ref.pager,
        selectedFilters = _ref.selectedFilters;

    if (pager && pager.page && pager.page >= pager.totalPages) {
        return;
    }

    var params = {
        year: year ? year : 2026,
        batchId: null,
        schoolName: schoolName,
        majorName: majorName,
        maxAvgScore: maxAvgScore ? maxAvgScore : 0,
        minAvgScore: minAvgScore ? minAvgScore : 0,
        maxScore: maxScore ? maxScore : 0,
        minScore: minScore ? minScore : 0,
        page: pager && pager.page ? pager.page + 1 : 1,
        size: pager && pager.size ? pager.size : 12
    };
    selectedFilters && Object.keys(selectedFilters).map(function (key) {
        var filters = selectedFilters[key];
        if (!filters || !filters.length) {
            return;
        }
        params[key + 'Ids'] = filters.map(function (filter) {
            return filter.id;
        });
    });
    return params;
}

function _reloadHiscoreList(params) {
    return {
        types: [t.RELOAD_HISCORE_LIST, t.RELOAD_HISCORE_LIST_SUCCESS, t.RELOAD_HISCORE_LIST_FAIL],
        promise: function () {
            function promise(client) {
                return client.post('/api/bp/hiscore/major', params);
            }

            return promise;
        }()
    };
}

function reloadHiscoreList(paramArray) {
    return function (dispatch, getState) {
        var state = getState().hiscoreYear;
        state.pager = null;
        if (paramArray && paramArray.length > 0) {
            paramArray.map(function (param, i) {
                state[param.paramType] = param.paramValue;
            });
        }
        var query = _createQuery(state);
        dispatch(_reloadHiscoreList(query));
    };
}

function _loadMoreHiscoreList(params, callback) {
    return {
        types: [t.LOAD_MORE_HISCORE_LIST, t.LOAD_MORE_HISCORE_LIST_SUCCESS, t.LOAD_MORE_HISCORE_LIST_FAIL],
        promise: function () {
            function promise(client) {
                return client.post('/api/bp/hiscore/major', params);
            }

            return promise;
        }(),
        afterSuccess: function () {
            function afterSuccess(dispatch, getState, response) {
                if (callback) {
                    callback();
                }
            }

            return afterSuccess;
        }()
    };
}

function loadMoreHiscoreList(callback) {
    return function (dispatch, getState) {
        var query = _createQuery(getState().hiscoreYear);
        if (!!query) {
            dispatch(_loadMoreHiscoreList(query, callback));
        }
    };
}

function getBatches(year) {
    if (year === "2016") {
        return {
            types: [t.GET_BATCHES, t.GET_BATCHES_SUCCESS, t.GET_BATCHES_FAIL],
            year: year,
            promise: function () {
                function promise(client) {
                    return client.get('/api/bp/hiscore/batch?year=' + year);
                }

                return promise;
            }()
        };
    } else {
        return {
            types: [t.GET_NEW_BATCHES, t.GET_NEW_BATCHES_SUCCESS, t.GET_NEW_BATCHES_FAIL],
            year: year,
            promise: function () {
                function promise(client) {
                    return client.get('/api/hiscore/help?year=' + year);
                }

                return promise;
            }()
        };
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/reducers/hiscore/hiscoreYear.js
// module id = 498
// module chunks = 0